import * as React from "react";
import Typography from "@material-ui/core/Typography";

export function Copyright(): React.ReactElement {
  return (
    <Typography data-testid={"copyright"} variant={"caption"} color={"textSecondary"} align={"center"}>
      Copyright &copy; MindSet {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}
